import { Injectable } from '@angular/core';
import { Router, Event, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { skip, filter } from 'rxjs/operators';

@Injectable()
export class FirstLoadService {
  private _firstLoad = true;

  public readonly router$: Observable<Event> = this.router.events.pipe(
    filter((event: Event) => event instanceof NavigationStart),
    skip(1)
  );

  public get firstLoad(): boolean {
    return this._firstLoad;
  }

  public set firstLoad(value: boolean) {
    this._firstLoad = value;
  }

  constructor(private router: Router) {
    this.router$.subscribe(() => (this.firstLoad = false));
  }
}
